
    import { Component, Prop, Vue } from 'nuxt-property-decorator';

    @Component
    export default class BreadCrumbItem extends Vue {
        @Prop() link;
        @Prop() text;
        @Prop() active;
    }
